export default "__VITE_ASSET__r2N2ERWm__"